<template>
  <div class="footSubmit">
    <el-button
      style="float: right; margin-right: 30px"
      size="small"
      type="primary"
      v-preventReClick
      @click="toPass()"
      >{{ passTitle }}</el-button
    >
    <el-button
      style="float: right; margin-right: 30px"
      size="small"
      v-preventReClick
      @click="toReject()"
      >{{ rejectTitle }}</el-button
    >

  </div>
</template>

<script>
export default {
  props: {
    rejectTitle: {
      type: String,
      default: '拒绝'
    },
    passTitle: {
      type: String,
      default: '通过'
    }
  },
  data() {
    return {
      pass: 'Y',
      reject: 'N',
      contents: ''
    }
  },
  methods: {
    // toNext() {
    //   this.$emit('activeName', this.activeName)
    // }
    toPass() {
      this.$emit('acceptName', this.pass)
    },
    toReject() {
      // debugger
      this.$emit('acceptName', this.reject)
      // this.dialogVisible = true
    }
    // sureChoice() {
    //   this.$emit('acceptName', this.reject, this.contents)
    //   this.dialogVisible = false
    // }
  }
}
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/components/enterprise/enterpriseFoot2.vue